import * as React from "react";
import { Grid } from "@material-ui/core";
import Sponsor from "./Sponsor";

const SponsorsPage: React.FC = () => {

    return (
        <Grid container spacing={2}>

            <Grid item xs={12} md={3}>
                <Sponsor
                    name="Babolat"
                    logoUrl="/logo/babolat.jpg"
                    url="https://babolat-tenis.pl/?utm_source=banner&utm_medium=banner&utm_campaign=smarttennis"
                    description="Babolat jest najstarszą firmą rakietową na świecie założoną we Francji. Babolat dostarcza na potrzeby SmartTennis piłeczki na finały oraz nagrody na konkursy w trakcie sezonu. Finaliści otrzymują vouchery na kwoty 1000zł (PRO), 600zł, 400zł, 200zł, 100zł do wykorzystania w sklepie Babolat." />
            </Grid>

            <Grid item xs={12} md={3}>
                <Sponsor
                    name="Błonia Sport"
                    logoUrl="/logo/blonia_sport.png"
                    url="https://bloniasport.pl/"
                    description="Partner SmartTennis, który udostępnia korty tenisowe na rozgrywanie turniejów oraz finałów." />
            </Grid>

            <Grid item xs={12} md={3}>
                <Sponsor
                    name="DP Optyk"
                    logoUrl="/logo/dpoptyk.jpg"
                    url="https://dpoptyk.pl/"
                    description="DP Optyk to to sieć salonów optycznych z 5 salonami w Krakowie." />
            </Grid>

            <Grid item xs={12} md={3}>
                <Sponsor
                    name="DUOLIFE"
                    logoUrl="/logo/duolife.png"
                    url="https://myduolife.com/"
                    description="DuoLife S.A. jest jedną z największych Polskich marek oferujących naturalne suplementy diety. Firma od 2012 roku stara się sprostać oczekiwaniom klientów nie tylko na rodzimym rynku, ale i za granicą. Produkty DuoLife dostępne są aż w 30 krajach świata." />
            </Grid>

            <Grid item xs={12} md={3}>
                <Sponsor
                    name="Karmello Chocolatier"
                    logoUrl="https://www.karmello.pl/karmello-theme/images/icons/header-logo.svg"
                    url="https://www.karmello.pl/"
                    description="Firma specjalizująca się w produkcji wysokiej jakości, ręcznie wytwarzanych wyrobów czekoladowych takich jak czekoladki, praliny, tabliczki czy owoce w czekoladzie, oferowanych zarówno przez sklep internetowy, jak i sieć sklepów firmowych." />
            </Grid>

            <Grid item xs={12} md={3}>
                <Sponsor
                    name="La-Le"
                    logoUrl="/logo/lale.png"
                    url="https://la-le.pl/"
                    description="Producent naturalnych kosmetyków do pielęgnacji ciała i twarzy wytwarzanych z ekologicznych produktów. Kosmetyki La-Le są wykonywane w krakowskiej manufakturze w sposób ręczny na bazie roślinnych składników i tradycyjnych receptur." />
            </Grid>

            <Grid item xs={12} md={3}>
                <Sponsor
                    name="Nova Klubova"
                    logoUrl="/logo/nowa_klubowa.png"
                    url="https://novaklubova.pl/"
                    description="Nova Klubova to połączenie klubu, coctail baru i restauracji w centrum krakowskiego kazimierza. Odbywają się tam imprezy na zakończenie sezonu ligowego." />
            </Grid>

            <Grid item xs={12} md={3}>
                <Sponsor
                    name="Pro-Fiz"
                    logoUrl="/logo/profiz.png"
                    url="https://www.facebook.com/profizcentrumfizjoterapii/"
                    description="Centrum fizjoterapii w Krakowie - zabiegi rehabilitacyjne, doradztwo, treningi, szybki powrót po kontuzji." />
            </Grid>

            <Grid item xs={12} md={3}>
                <Sponsor
                    name="Social Media Now"
                    logoUrl="https://socialmedianow.pl/wp-content/uploads/2021/06/logo-cut-black.png"
                    url="https://socialmedianow.pl/"
                    description="Agencja marketingowa specjalizująca się w prowadzeniu kampanii reklamowych i strategii komunikacji w mediach społecznościowych, w szczególności na platformach takich jak Facebook, Instagram, LinkedIn czy TikTok, a także oferująca kompleksowe zarządzanie reklamami i analizę ich skuteczności." />
            </Grid>

            <Grid item xs={12} md={3}>
                <Sponsor
                    name="Teniskrakow Maciej Nowacki"
                    logoUrl="https://sklep.teniskrakow.pl/wp-content/uploads/2024/12/cropped-teniskrakowlogoczarne.png"
                    url="https://teniskrakow.pl/"
                    description="Krakowska szkoła tenisa ziemnego, która prowadzi treningi indywidualne i grupowe dla dzieci, młodzieży oraz dorosłych na różnych poziomach zaawansowania oraz organizuje obozy i wyjazdy tenisowe w Polsce i za granicą." />
            </Grid>

            <Grid item xs={12} md={3}>
                <Sponsor
                    name="Winnica Novi"
                    logoUrl="/logo/winnicanovi.png"
                    url="https://winnicanovi.pl/"
                    description="Winnica Novi to winnica leżąca w otulinie Ojcowskiego Parku Narodowego pod Krakowem w Cianowicach." />
            </Grid>

        </Grid>
    )

};

export default SponsorsPage;

